<template>
    <div>
      <TopMenu v-if="!isLoginPage"/>
      <v-row no-gutters dense>
        <v-col>
          <RouterView></RouterView>
        </v-col>
      </v-row>
      <!-- <SessionExpire v-if="isSessionExpire" /> -->
    </div>
  </template>
  
  <script>
  import TopMenu from "../menu/TopMenu.vue";
  //import SessionExpire from "../components/others/SessionExpire.vue"
  //import socket2 from "@/Socket-Client2.js"
  export default {
    data(){
         return{
          
         }
    },
    components: {
        TopMenu,
     // SessionExpire
    },
    created(){
        console.log(this.$store.state.sessionExpire);
        
    },
    watch:{
      isSessionExpire(){
        this.logout();
      },
      
    },
    computed:{
      isSessionExpire() {
      return this.$store.state.sessionExpire;
    },
    isLoginPage() {
      return this.$route.name === "loginview" || this.$route.name === "forgetpassword"; // Ensure your login route has the name "Login"
    }
    },
    methods:{
      logout() {
            localStorage.clear();
            window.location.reload()
        }
    }
   
   
  };
  </script>
  <style scoped>
  >>> .v-snackbar__content {
    flex-grow: 1;
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 0px;
    text-align: initial;
  }
 

  </style>
  